import { createApi, fakeBaseQuery, SkipToken } from "@reduxjs/toolkit/query/react";
import { db } from "@/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { addLoadingTask, deleteLoadingTask } from "@/store/uiSlice";
import { RootState } from "@/store/store";
import { Template } from "@/types";

export const newtemplatesApi = createApi({
  reducerPath: "newTemplates",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["newTemplates"],
  endpoints: (builder) => ({
    fetchTemplateById: builder.query({
      queryFn: async (templateId: string | SkipToken, { dispatch }) => {
        const TASK = "Plantilla";
        try {
          dispatch(addLoadingTask(TASK));
          const docRef = doc(db, "templates", templateId);
          const snapshot = await getDoc(docRef);
          const response = {
            id: templateId,
            ...snapshot.data(),
          };
          return { data: response as Template };
        } catch (error) {
          console.error(error);
          throw error;
        } finally {
          dispatch(deleteLoadingTask(TASK));
        }
      },
      providesTags: ["newTemplates"],
    }),
    updateTemplateStyle: builder.mutation({
      queryFn: async ({ templateId, styles }: { templateId: Template["id"]; styles: string }, { getState, dispatch }) => {
        const store = getState() as RootState;
        const TASK = "Actualizar estilos de plantilla";
        try {
          dispatch(addLoadingTask(TASK));

          if (!store.auth?.user?.uid || !templateId || !styles) {
            throw new Error("No template available");
          }

          const docRef = doc(db, `templates/${String(templateId)}`);

          const payload = {
            styles,
            lastUpdatedBy: store.auth.user.uid,
            lastUpdatedAt: Date.now(),
          };
          const response = await updateDoc(docRef, payload);

          return { data: response };
        } catch (error) {
          return { error };
        } finally {
          dispatch(deleteLoadingTask(TASK));
        }
      },
      invalidatesTags: ["newTemplates"],
    }),
  }),
});

export const { useFetchTemplateByIdQuery, useUpdateTemplateStyleMutation } = newtemplatesApi;
